jQuery(document).ready(function(){

if(jQuery('body').hasClass('template-index')){
jQuery(document).ready(function(){


Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var ctaCopy = "SHOP NOW";
  var lnk = 'https://www.ventgrips.com/products/standard-mount';
  var stickyCopy = 'Get The VentGripz Magnetic Mount';
  
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="ventgripz-st-container" id="ventgripz-st-containerID"> <div class="ventgripz-st-container__outer"> <div class="ventgripz-st-container__inner"> <div class="ventgripz-st-copy">'+stickyCopy+'</div><div class="ventgripz-st-item_column__button"><a href="'+lnk+'" class="ventgripz-st-item__button">'+ctaCopy+'</a></div></div></div></div></div>';
var y = document.getElementsByTagName('body');
if (document.getElementsByClassName('ventgripz-st-container').length == 0) {
    y[0].appendChild(sticky);
}

  
var mc = window.matchMedia("(min-width: 767px)");

var elem = document.getElementById("ventgripz-st-containerID");
function slideShow() {
    jQuery('body').addClass('ventgripz-sticky');
}
function slideHide() {
   jQuery('body').removeClass('ventgripz-sticky');
}
  
jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
     if (y > 400) {
        slideShow();
    } else {
        slideHide();
    }
    
}); 
  }); 
}
});

var ur = window.location.href;
if(ur.includes('/collection')){
  jQuery(document).ready(function(){
	jQuery('span.ventgripz-quickview').click(function(){
      var q = jQuery(this);
  var qq = 0; var timerqq = setInterval(function(){
  if(jQuery('.qview-button').length) {
	q.parent().parent().find('.qview-button').eq(0).click();
clearInterval(timerqq);}if( qq > 200){clearInterval(timerqq);}qq++;}, 50);
}); 
});
}

var ur = window.location.href;
if(ur.includes('/product')){
 var loo = 0; var timerloo = setInterval(function(){
  if($('.loox-rating span').length) {
	var rev = $('.loox-rating span').text();
     rev = rev.replace(')', ' Customer Reviews)');
      $('.loox-rating span').text(rev)
      
      $('.loox-rating span').click(function(){
   $('html, body').animate({
        scrollTop: $('div#shopify-block-loox-product-reviews').offset().top - 100
    }, 500);
}); 
     
      
clearInterval(timerloo);}if( loo > 200){clearInterval(timerloo);}loo++;}, 50); 
    
    
    $('.features_mn').eq(0).before($('<span style="display: none" class="before-position"></span>'));
    
    if(window.innerWidth < 720){
        $('.product-form').eq(0).after($('.features_mn').eq(0));
     }
    else{
        $('.before-position').eq(0).after($('.features_mn').eq(0));
    }
    
    window.onresize = function(){
         if(window.innerWidth < 720){
        $('.product-form').eq(0).after($('.features_mn').eq(0));
     }
    else{
        $('.before-position').eq(0).after($('.features_mn').eq(0));
    }
    }
     jQuery(document).ready(function(){
 sticky();
});
}
    
  
    
    
function sticky(){
var ur = window.location.href;

  Element.prototype.appendAfterThis = function(element) {
    element.parentNode.insertBefore(this, element.nextSibling);
};
var sticky = document.createElement('div');
sticky.innerHTML = '<div class="ventgripz-st-container" id="ventgripz-st-containerID"> <div class="ventgripz-st-container__outer"><div class="ventgripz-product-cont"><div class="ventgripz-product-name"></div><div class="ventgripz-product-price"></div></div> <div class="ventgripz-st-container__inner"> <div class="ventgripz-select-container"> <div class="ventgripz-st-select" id="st-select0"> <span>Color</span> <select> <option></option> </select> </div><div class="ventgripz-st-select" id="st-select1"> <span>Type</span> <select> <option></option> </select> </div><div class="ventgripz-st-select" id="st-select2"> <span>Type</span> <select> <option></option> </select> </div></div><div class="ventgripz-st-item_column__button"><a class="ventgripz-st-item__button" rel="nofollow">Add to Cart</a></div></div></div></div>';
var y = document.getElementsByTagName('body');
if(document.getElementsByClassName('ventgripz-st-container').length == 0){
  y[0].appendChild(sticky);
  

jQuery('.ventgripz-product-name').html(jQuery('.product__title').eq(0).html());
  
 
function populateOptions(select, labels){
  var selected = 0;
  labels = labels.eq(0).find('.input-checkbox');
  for(var i =0; i < labels.length; i++){
      var option = document.createElement('OPTION');
        
      var t = document.createTextNode(labels.eq(i).attr('value'));
      option.appendChild(t);
   	  option.id = i;
      select.appendChild(option);
    
    	if(i ==0){
          select.removeChild(select.firstElementChild);
          
        }
       if(labels.eq(i).attr('checked')){
           selected = i;
       }
  }
  
  select.selectedIndex = selected;
}
  
  jQuery('.ventgripz-st-item__button').click(function(){
      
   if(!jQuery('.ventgripz-st-item__button').hasClass("ventgripz-st-disabled")){
     
      jQuery('.smart-payments .button:not(:disabled)').eq(0).click();
      }
    
   
  });
  
 if(jQuery('.product-options .inline-field-wrapper').eq(0).length >= 1){
 jQuery('body').addClass('has-variant');
   jQuery('.ventgripz-st-select span').eq(0).html(jQuery('span.input-field-title').eq(0).html());
  jQuery('#st-select0').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select0').getElementsByTagName('select')[0], jQuery('.product-options .inline-field-wrapper:eq(0)'));
}
    
    
  
 if(jQuery('.product-options .inline-field-wrapper').eq(1).length >= 1){
 
   jQuery('.ventgripz-st-select span').eq(1).html(jQuery('span.input-field-title').eq(1).html());
  jQuery('#st-select1').attr('style' ,'display: flex');
  populateOptions(document.getElementById('st-select1').getElementsByTagName('select')[0], jQuery('.product-options .inline-field-wrapper:eq(1)'));
}
    
    
    
};
  
     function checkIfDisabled() {
         setTimeout(function () {
             var elem = jQuery('.smart-payments .button span').eq(0);
             jQuery('.ventgripz-st-item__button').html(elem.html());
             if (elem.html().toUpperCase() != 'ADD TO CART') {
                 jQuery('.ventgripz-st-item__button').html(elem.html());
                 jQuery('.ventgripz-st-item__button').addClass('ventgripz-st-disabled');
             } else {
                 jQuery('.ventgripz-st-item__button').removeClass('ventgripz-st-disabled');
             }
         }, 100);
     }
//checkIfDisabled();
  jQuery('.r > label').click(function(){
   		checkIfDisabled();
});
jQuery('#st-select0 > select').change(function(){
  checkIfDisabled();
  var i = jQuery(this).find(":selected").attr('id');
  jQuery('.product-options .inline-field-wrapper:eq(0) input').eq(i).click();
 
});
jQuery('#st-select1 > select').change(function(){
    checkIfDisabled();
 var i = jQuery(this).find(":selected").attr('id');
  jQuery('.product-options .inline-field-wrapper:eq(1) input').eq(i).click();
  
});
  
jQuery('.product-options .inline-field-wrapper:eq(0) .input-checkbox-title').click(function(){
checkIfDisabled();
 jQuery('#st-select0 > select').val(jQuery(this).html());
});
  
jQuery('.product-options .inline-field-wrapper:eq(1) .input-checkbox-title').click(function(){
checkIfDisabled();
 jQuery('#st-select1 > select').val(jQuery(this).html());
});
    
  checkIfDisabled();
  
function isVisible(elem){
var elementTop = elem.offset().top;
var elementBottom = elementTop + elem.outerHeight();
var viewportTop = jQuery(window).scrollTop();
var viewportBottom = viewportTop + jQuery(window).height();
return elementBottom > viewportTop && elementTop < viewportBottom;
};
       
var mc = window.matchMedia("(min-width: 767px)");
        
        
    var elem = document.getElementById("ventgripz-st-containerID");      
    function slideShow() {
          jQuery('body').addClass('ventgripz-sticky');
    }
          		
     function slideHide() {    
        jQuery('body').removeClass('ventgripz-sticky');
     }
              
    jQuery(document).scroll(function() {
    var y = jQuery(this).scrollTop();
    if (y > jQuery('.smart-payments .button:not(:disabled)').eq(0).offset().top) {
       slideShow();
            
    } else {
  
        slideHide();
        
    }
});   
                             



}              

